var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertExists } from '@blocksuite/global/utils';
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { WithDisposable } from '../with-disposable.js';
export class WidgetElement extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this.handleEvent = (name, handler, options) => {
            this._disposables.add(this.host.event.add(name, handler, {
                flavour: options?.global ? undefined : this.flavour,
            }));
        };
    }
    get widgetName() {
        return this.path[this.path.length - 1];
    }
    get hostPath() {
        return this.path.slice(0, -1);
    }
    get blockElement() {
        const parentElement = this.parentElement;
        assertExists(parentElement);
        const nodeView = this.host.view.getNodeView(parentElement);
        assertExists(nodeView);
        return nodeView.view;
    }
    get flavour() {
        assertExists(this.blockElement);
        return this.blockElement.model.flavour;
    }
    get std() {
        return this.host.std;
    }
    bindHotKey(keymap, options) {
        this._disposables.add(this.host.event.bindHotkey(keymap, {
            flavour: options?.global ? undefined : this.flavour,
        }));
    }
    connectedCallback() {
        super.connectedCallback();
        this.path = this.host.view.calculatePath(this);
    }
    render() {
        return null;
    }
}
__decorate([
    property({ attribute: false })
], WidgetElement.prototype, "host", void 0);
__decorate([
    property({ attribute: false })
], WidgetElement.prototype, "page", void 0);
//# sourceMappingURL=widget-element.js.map